import React from 'react';

export class V2ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { failed: false, error: null }; }
  static getDerivedStateFromError(error) { return { failed: true, error }; }
  componentDidCatch(error, info) { console.error('UI v2 preview failed', error, info); }
  render() {
    if (!this.state.failed) return this.props.children;
    return <div className="v2-failure-screen" role="alert">
      <img src="./branding/the-dope-man-logo.webp" alt="The Dope Man" />
      <span>UI v2 · PREVIEW</span><h1>The new interface ate shit.</h1>
      <p>Your game run is still server-side and untouched. Drop back to the stable interface or retry the preview.</p>
      <div><button onClick={this.props.onStable}>RETURN TO STABLE UI</button><button onClick={() => this.setState({ failed: false, error: null })}>RETRY</button></div>
      <small>{this.state.error?.message || 'Preview render failure'}</small>
    </div>;
  }
}
